import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=77ec22e1&scoped=true&"
import script from "./CustomerDetail.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetail.vue?vue&type=style&index=0&id=77ec22e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ec22e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDivider,VRow,VSelect,VTextField})
